import Ls from '@/services/ls'
import * as types from './mutation-types'
import * as userTypes from '../user/mutation-types'
import * as rootTypes from '../../mutation-types'
import router from '@/router.js'

export const login = ({ commit, dispatch, state }, data) => {
  let loginData = {
    username: data.email,
    password: data.password
  }
  return new Promise((resolve, reject) => {
    axios.post('/api/auth/login', loginData).then((response) => {
      // Check if OTP is sent (OTP flow)
      if (response.data.otp_sent) {
        resolve(response)
        return
      }

      // Normal login flow (no OTP)
      let token = response.data.data.access_token
      Ls.set('auth.token', token)
      Ls.set('role', response.data.role)
      Ls.set('reset_password', response.data.password_status)
      Ls.set('user_email', response.data.email)
      Ls.set('account_type', response.data.account_type)
      commit('user/' + userTypes.RESET_CURRENT_USER, null, { root: true })
      commit(rootTypes.UPDATE_APP_LOADING_STATUS, false, { root: true })
      commit(types.AUTH_SUCCESS, token)
      window.toastr['success']('Login Successful')
      resolve(response)
    }).catch(err => {
      commit(types.AUTH_ERROR, err.response)
      Ls.remove('auth.token')
      reject(err)
    })
  })
}

export const register = ({ commit, dispatch, state }, data) => {
  let registerData = {
    name: data.name,
    company: data.company,
    website: data.website,
    phone: data.phone,
    email: data.email,
    password: data.password,
    role: 'admin'
  }
  return new Promise((resolve, reject) => {
    axios.post('/api/auth/register', registerData).then((response) => {
      resolve(response)
    }).catch(err => {
      reject(err)
    })
  })
}

export const refreshToken = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    let data = {
      token: Ls.get('auth.token')
    }
    console.log('REFRESH ACTION')
    axios.post('/api/auth/refresh_token', data).then((response) => {
      let token = response.data.data.token
      Ls.set('auth.token', token)
      commit(types.REFRESH_SUCCESS, token)
      resolve(response)
    }).catch(err => {
      reject(err)
    })
  })
}

export const logout = ({ commit, dispatch, state }, noRequest = false) => {
  if (noRequest) {
    commit(types.AUTH_LOGOUT)
    Ls.remove('auth.token')
    Ls.remove('selectedCompany')
    Ls.remove("role")
    Ls.remove("reset_password")
    Ls.remove("user_email")
    Ls.remove('account_type');

    router.push('/login')

    return true
  }

  return new Promise((resolve, reject) => {
    axios.get('/api/auth/logout').then((response) => {
      commit(types.AUTH_LOGOUT)
      Ls.remove('auth.token')
      Ls.remove('selectedCompany')
      Ls.remove('role')
      Ls.remove('reset_password')
      Ls.remove('user_email')
      Ls.remove('account_type')

      router.push('/login')
      window.toastr['success']('Logged out!', 'Success')
    }).catch(err => {
      reject(err)
      commit(types.AUTH_LOGOUT)
      Ls.remove('auth.token')
      Ls.remove('selectedCompany')
      Ls.remove('role')
      Ls.remove('reset_password')
      Ls.remove('user_email')
      Ls.remove('account_type')

      router.push('/login')
    })
  })
}

export const loginOnBoardingUser = ({ commit, dispatch, state }, token) => {
  commit(types.AUTH_SUCCESS, token)
}

export const verifyOtp = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    axios.post('/api/auth/verifyOtp', data).then((response) => {
      if(response.data.expired_otp)
      {
        window.toastr["error"]("OTP has Expired. Please Resend");
        reject(response)
      }
      else if (response.data.invalid_otp) {
        window.toastr["error"]("OTP you entered is Incorrect");
        reject(response)
      }
      else
      {
        let token = response.data.data.access_token
        Ls.set('auth.token', token)
        Ls.set('role', response.data.data.role)
        Ls.set('reset_password', response.data.data.password_status)
        Ls.set('user_email', response.data.data.email)
        Ls.set('account_type', response.data.data.account_type)
        commit('user/' + userTypes.RESET_CURRENT_USER, null, { root: true })
        commit(rootTypes.UPDATE_APP_LOADING_STATUS, false, { root: true })
        commit(types.AUTH_SUCCESS, token)
        window.toastr['success']('Login Successful')
        resolve(response)
      }
    }).catch(err => {
      commit(types.AUTH_ERROR, err.response)
      Ls.remove('auth.token')
      reject(err)
    })
  })
}


export const resendOtp = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    axios.post('/api/auth/resendOtp', data).then((response) => {
      if(response.data.resend_successful)
      {
        window.toastr["success"]("OTP Sent");
        resolve(response)
      }
      reject(response)
    }).catch(err => {
      commit(types.AUTH_ERROR, err.response)
      Ls.remove('auth.token')
      reject(err)
    })
  })
}
